import { Ref } from "vue";

const waitUntilTruePromise = async (statement: Ref<boolean> | (() => boolean), time: number = 100) => {
    while (!(typeof statement == "function" ? statement() : statement.value)) {
        await new Promise((resolve) => setTimeout(resolve, time));
    }
};
const timeoutPromise = (timeout: number = 1000) => new Promise((resolve, reject) => setTimeout(reject, timeout));

export const waitUntilTrue = (
    statement: Ref<boolean> | (() => boolean),
    time: number = 100,
    timeout: number = 10000,
) => {
    const to = timeout <= time ? time * 2 : timeout;
    return Promise.race([waitUntilTruePromise(statement, time), timeoutPromise(to)]);
};

export const wait = (timeout: number = 1000) => new Promise((resolve) => setTimeout(resolve, timeout));
